// Copyright (c) 2016 Deere & Company

import {updateClaimModalMode, updateCreateClaimModalVisibility} from './create-claim-modal-visibility';
import actions from '../action-list';
import {createMassChannelPdiClaim} from './validate-claim';
import {getUpdatedMassChannelPdiClaim} from '../services/update-mass-channel-pdi-claim';
import {isActionResetFormValidation} from '../../../shared/services/claim-shared-helper';

export const updateSelectedAction = selectedAction =>

    (dispatch, getState) => {

        const updatedClaim = getUpdatedMassChannelPdiClaim(getState().claims.massChannelPdi.claim, selectedAction);

        const updateModalVisibility = () => {

            updateClaimModalMode('CREATE')(dispatch);
            updateCreateClaimModalVisibility(true)(dispatch);

        };

        const updateIsEditable = () => {

            dispatch({
                isEditable: true,
                type: actions.UPDATE_CLAIM_MASS_CHANNEL_PDI_IS_EDITABLE
            });

            dispatch({
                type: actions.REVISE_CLAIM_MASS_CHANNEL_PDI
            });

        };

        if (isActionResetFormValidation(selectedAction.id)) {

            dispatch({
                type: actions.RESET_CLAIM_MASS_CHANNEL_PDI_FORM_VALIDATION
            });

        }

        const selectedActionIdTypes = {
            CRT: updateModalVisibility,
            REVISE: updateIsEditable
        };

        const updateType = selectedActionIdTypes[selectedAction.id];

        return updateType ? updateType() : createMassChannelPdiClaim(updatedClaim)(dispatch, getState);

    };



// WEBPACK FOOTER //
// ./src/claim/marketing/mass-channel-pdi/action-creators/update-selected-action.js